import { makeAutoObservable } from "mobx";
import { AppStore } from "store/App.store";
import { AccountIntegrationMRIRadarNegotiatorsStore } from "./AccountIntegrationMRIRadarNegotiators.store";

export class AccountIntegrationMRIRadarStore {
  public accountIntegrationMRIRadarNegotiatorsStore: AccountIntegrationMRIRadarNegotiatorsStore;
  public accountId: number;

  constructor(root: AppStore, accountId: number) {
    makeAutoObservable(this, {}, { autoBind: true });
    this.accountIntegrationMRIRadarNegotiatorsStore = new AccountIntegrationMRIRadarNegotiatorsStore(
      root,
      accountId
    );
    this.accountId = accountId;
  }
}
